import { COUPON_TYPES } from '../../../../services/exports/Constants';

const Coupons: Record<COUPON_TYPES, string> = {
  [COUPON_TYPES.PROMO_CODE]: 'Code promo {{code}} appliqué',
  [COUPON_TYPES.CASHBACK]: 'Points de fidélité appliqués',
  [COUPON_TYPES.REWARD]: 'Récompense appliquée',
  [COUPON_TYPES.GIFT_CARD]: 'Carte cadeau appliquée',
};

export default Coupons;
